export default {
  dashboard: {
    cgvText: 'Por favor, lea las condiciones generales de venta a continuación y confírmelas para continuar navegando en su Área de Cliente.',
    maintenance: 'Estimado cliente,<br /><br />\n' +
        'Les informamos que excepcionalmente nuestro servicio de atención al cliente permanecerá cerrado el jueves 30 de mayo. De hecho, estamos organizando un seminario empresarial para mejorar nuestros servicios y nuestro soporte.<br />\n' +
        'Estableceremos un servicio mínimo para monitorear el correcto funcionamiento de nuestra plataforma y sus herramientas.<br /><br />\n' +
        'Volveremos al día siguiente, viernes 31 de mayo, listos para satisfacer todas tus necesidades.<br /><br />\n' +
        'Le agradecemos su comprensión y lealtad.<br /><br />\n' +
        'Atentamente,\n<br />El equipo de Ubiflow.\n',
    linkedInConnectNOK: 'Publicación automatizada en LinkedIn.<br>',
    dialogTitle: 'Bienvenido a su nuevo Espacio Cliente',
    dialogWelcome: 'Hola,<br><br>' +
            'Ha sido redirigido automáticamente a su nuevo Espacio Cliente Ubiflow.<br><br>' +
            '¿ Qué ha cambiado ?<br>' +
            '- una mayor <strong>reactividad</strong> para una difusión siempre más rápida,<br>' +
            '- unos <strong>datos enriquecidos</strong> para mejorar la gestión de su negocio,<br>' +
            '- una <strong>nueva interfaz</strong> para una navegación simplificada,<br>' +
            '- un acceso ya posible desde su <strong>teléfono móvil</strong>.',
    dialogTextBottom: 'Puede acceder a su antiguo espacio cliente todavía durante unos meses. ' +
            'Para eso, haga clic en "Regresar al antiguo espacio cliente" en en la esquina superior derecha de la pantalla.',
    dialogClose: 'Cerrar',
    myAds: 'Mis anuncios',
    activeAds: 'anuncios activados en su portafolio',
    myAds_link: 'Acceder a mis anuncios',
    myDiffusions: 'Mis difusiones',
    reportDate: 'Informe al',
    diffusionPercentageText: 'De anuncios correctamente difundidos',
    myIntegrations: 'Mis integraciones',
    integrations: 'Integraciones',
    fullReportLink: 'Ver el informe completo',
    myLastAds: 'Mis ultimos anuncios',
    myLastAdsLink: 'Ver todos los anuncios',
    cmDiscoverTitle: 'Contact Manager, herramienta de centralización y gestión de sus contactos.',
    cmDiscoverText: 'Centralice y gestione todos sus leads (llamadas y correos) en tiempo real en una sola interfaz.',
    cmDiscoverButton: 'Descubrir el producto Contact Manager',
    cmYouReceived: 'ha recibido',
    cmContactsWithCount: '{{count}} contacto',
    cmContactsWithCount_plural: '{{count}} contactos',
    cmFor: 'para',
    cmAdsWithCount: '{{count}} anuncio',
    cmAdsWithCount_plural: '{{count}} anuncios',
    cmLast7Days: 'durante los 7 últimos días.',
    cmPortals: 'Los portales',
    cmAds: 'Los anuncios',
    cmColumnTitle: 'Título',
    cmColumnContacts: 'Contactos',
    metaTitle: 'Panel principal',
    beContacted: 'Interesado en el producto? Ser contacto por un asesor.',
    decouvrir: 'Descubrir el producto',
    activePrograms: 'programas activos en su portafolio',
    myPrograms: 'Mis programas',
    myPrograms_link: 'Aceder a mis programas',
    beCall: 'Ser contacto por un asesor',
    titleProduitNonActive: 'ESTA FUNCIÓN NO ESTÁ ACTIVADA EN SU SUSCRIPCIÓN.',
    txtProduitNonActiveDiffusion: 'Benefíciese de todas las ventajas de difundir sus anuncios con Ubiflow. Envíamos sus anuncios a todos los portales regionales, nacionales y especializados, también a su página web. Maneje y programe la seleción de sus anuncios, personaliza su información de contacto y monitorea sus difusiones gracias a nuestros reportes de difusión y de presencia.',
    txtProduitNonActiveCM: 'Centralice y gestione todos sus leads (llamadas y correos) en tiempo real en una sola interfaz.',
    txtProduitNonActiveSocialManagment: 'Descubra la oferta Social Manager y desarrolle una verdadera estrategia Social Media. Ubiflow le ofrece una solución llave en mano para ahorrarle tiempo. Publique automáticamente sus anuncios en sus redes sociales (Facebook, Instagram, LinkedIn, Google Business Profile) y cree su propio contenido editorial con la ayuda de la inteligencia artificial. Nuestro calendario editorial integrado facilita el seguimiento de todas sus publicaciones. Además, se han añadido otras funciones para mejorar tu visibilidad y maximizar tu impacto en las redes sociales.',
    emailSend: 'Su solicitud ha sido enviada. Nuestro equipo lo contactará lo más pronto posible.',
    txtPopupSFC: '<p class="text-justify" style="color: black">Desde este nuevo espacio cliente, acceda fácilmente a su solucíon de referencia local ' +
            '"Se Faire Connaître", dando <strong>clic a su izquierda en la parte "Presencia Local - Se Faire Connaître"</strong>. ' +
            '</p><p class="text-justify" style="color: black">También descubra todos nuestros otros productos. </p><p class="text-justify"style="color: black">Recorde de agregar a sus favoritos la liga de conexión a ' +
            'su nuevo espacio: <a href="https://espace-client.ubiflow.net/login">https://espace-client.ubiflow.net/login</a>. de difusión and Lead management adaptato a su actividad. ' +
            'No dude en contactarnos para una <strong>demonstración gratuita</strong>.</p>',
    txtChekboxPopupSFC: 'Entendí. No volver a mostrar este mensaje para mis futuras conexiones.',
    txtTitrePopupSFC: 'Bienvenido a su nuevo Espacio Cliente Ubiflow !',
    contactsEvolution: 'Evolución del número de contactos',
    vsLastMonth: 'respecto al mes anterior',
    vsLastDay: 'respecto al día anterior',
    vsLastWeek: 'respecto a la semana anterior',
    vsLastQuarter: 'respecto al trimestre anterior',
    quarter: 'T',
    kpi: 'Indicadores del período',
    contactsUnit: 'contactos',
    requestDemo: 'Solicitar una demostración',
    noData: 'Sin datos',
    recentInstallationText: 'Como la solución se instaló recientemente, estos datos y curva son ficticios. Su tiempo de flujo se calculará después de 3 meses.',
    moreInfoContactsEvolution: 'Más información sobre la evolución de sus contactos',
    dateRangeMonthly: 'de {{from}} a {{to}}',
    dateRangeDaily: 'del {{from}} al {{to}}',
    socialEvolutionTitle: 'Evolucion del volumen de interacciones',
    socialInteractionsUnit: 'interacciones',
    moreInfoSocialEvolution: 'Mas informacion sobre sus estadisticas en redes sociales',
    delaiEcoulementTitle: 'Tiempo de escoamento de los anuncios',
    delaiEcoulementUnit: 'días',
    delaiEcoulementNoData: 'Ningún anuncio escoado en los últimos 7 días — tiempo de escoamento no disponible.',
    delaiEcoulementAverage7DaysLabel: 'Media en el periodo de los últimos 7 días',
    delaiEcoulementUnitAverage7Days: 'días (media 7 días)',
    delaiEcoulementEvolution: 'Evolución del tiempo de escoamento',
    txtProduitNonActiveDelaiEcoulement: 'Siga el tiempo medio de escoamento de sus anuncios y compare su rendimiento a lo largo del tiempo. Optimice su estrategia de difusión gracias a indicadores clave adaptados a su antigüedad.',
    adLifetimeDetailLink: 'Detalle del tiempo de escoamento',
    adLifetimeDetailReference: 'Referencia',
    adLifetimeDetailCreationDate: 'Fecha de creación',
    adLifetimeDetailDeletionDate: 'Fecha de eliminación',
    adLifetimeDetailLifetimeDays: 'Tiempo de escoamento (días)',
    adLifetimeDetailEmpty: 'Ningún anuncio eliminado',
    adLifetimeDetailExportFilename: 'anuncios_eliminados',
    adLifetimeDetailExportButton: 'Exportar'
  }
}
